const homePage = require('./pages/homepage');
const preview = require('./includes/img-preview');
const header = require('./includes/header');
const animations = require('./includes/animations');
const playVideo = require('./includes/video-with-btn-play');
const projects = require('./pages/projects');
const news = require('./pages/news');
const contact = require('./pages/contact');
const animationIcon = require("./includes/animation-icon");

$("document").ready(function () {
    //pages
    header();
    homePage();
    preview();
    animations();
    projects();
    news();
    contact();
    playVideo();
    setTimeout(() => {
        animationIcon();
    }, 100);
    const lazyContent = new LazyLoad({});
});

isScrolled = false;
let hasScrolledPastBeginText = false;

$(window).on('resize scroll load', function () {
    setTimeout(() => {
        animationIcon();
    }, 100);

    // Kiểm tra xem người dùng đã scroll qua beginText chưa
    if ($(window).scrollTop() > $('#beginText').offset().top) {
        hasScrolledPastBeginText = true;
    }

    setTimeout(() => {
        if(isScrolled || hasScrolledPastBeginText) return;
        $('html, body').animate({
            scrollTop: $('#beginText').offset().top
        }, 1000);
        isScrolled = true;
    }, 8200);
});

$(window).resize(function () {

})
